"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Campaign = exports.CAMPAIGN_KEYWORDS = void 0;
var cookie_1 = require("./cookie");
var utils_1 = require("./utils");
exports.CAMPAIGN_KEYWORDS = [
    "gclid",
    "fbclid",
    "msclkid",
    "utm_source",
    "utm_id",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
];
var LOGSPOT_CAMPAIGN_COOKIE_ID = "lgspt_c";
var DEFAULT_EXPIRATION = 7 * 24 * 60 * 60; // 7 days
var Campaign = /** @class */ (function () {
    function Campaign(sdkConfig) {
        this.sdkConfig = sdkConfig;
        var cookieParams = this._getCamapignCookie();
        var params = __assign(__assign({}, cookieParams), this._getParams());
        if (sdkConfig.stickyCampaigns) {
            this._setCampaignCookie(params);
        }
        this.campaignParams = params;
    }
    Campaign.prototype.getCampagingParams = function () {
        var params = this._getParams();
        if (this.sdkConfig.stickyCampaigns) {
            return __assign(__assign({}, this.campaignParams), params);
        }
        return params;
    };
    Campaign.prototype._getCamapignCookie = function () {
        var cookie = (0, cookie_1.getCookie)(LOGSPOT_CAMPAIGN_COOKIE_ID);
        var decoded = cookie ? JSON.parse((0, utils_1.UnicodeDecodeB64)(cookie)) : {};
        return decoded;
    };
    Campaign.prototype._setCampaignCookie = function (campaignParams) {
        var _a, _b;
        (0, cookie_1.setCookie)({
            name: LOGSPOT_CAMPAIGN_COOKIE_ID,
            value: (0, utils_1.b64EncodeUnicode)(JSON.stringify(campaignParams)),
            expiresInSeconds: (_a = this.sdkConfig.cookieExpirationInSeconds) !== null && _a !== void 0 ? _a : DEFAULT_EXPIRATION,
            domain: (_b = this.sdkConfig.cookieDomain) !== null && _b !== void 0 ? _b : null,
        });
    };
    Campaign.prototype._getParams = function () {
        var urlSearchParams = new URLSearchParams(window.location.search);
        var queryParams = Object.fromEntries(urlSearchParams.entries());
        return exports.CAMPAIGN_KEYWORDS.reduce(function (acc, next) {
            var _a;
            var _b;
            if ((_b = queryParams[next]) === null || _b === void 0 ? void 0 : _b.length) {
                return __assign(__assign({}, acc), (_a = {}, _a[next] = queryParams[next], _a));
            }
            return acc;
        }, {});
    };
    return Campaign;
}());
exports.Campaign = Campaign;
